import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "./CreateEditUser.scss"; // Make sure to import the CSS file
import { Link, useNavigate, useLocation } from "react-router-dom";
import { callAPI } from "../../../../axios";
import { Switch, Autocomplete, TextField } from "@mui/material";
import BasicModal from "../../../core/BaseComponents/Modal";

const CreateEditUser = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [cancelPopupClearHotel, setCancelPopupClearHotel] = useState(false);

  // This stores the function to run if "Yes" is clicked in modal
  const [pendingClear, setPendingClear] = useState(null);

  const [roles, setRoles] = useState([]);
  const [hotels, setHotelsList] = useState([]);
  const [cancelPopup, setCancelPopup] = useState(false)
  const [createUpdatePopUp, setCreateUpdatePopUp] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: { enabled: true }
  });

  const today = new Date().toISOString().split("T")[0];

  const handleSwitchChange = (checked) => {
    setValue("enabled", checked);
  };

  const cancelPopupHandlerClearHotel = () => {
    if (pendingClear) pendingClear();
    setPendingClear(null);
    setCancelPopupClearHotel(false);
  };

  const onSubmit = (data) => {
    let method = "POST";
    let url = "/user";
    if (location?.state?.isEditUser) {
      method = "PUT";
      url = `user?sid=${location?.state?.sid}`;
    }
    if (location?.state?.isPendingApprovalStatus) {
      method = "PUT";
      url = `user/signup-approve?sid=${location?.state?.sid}`;
    }
    let chainId = "";
    data?.chainId?.map((item,index)=>{
      chainId = chainId + `${index?",":""}${item?.chainID}`
    })
    // const chainId = data.chainId ? data.chainId.chainID : null;
    const payload = { ...data, chainId, roleSids: [data.roles.sid.toString()] };
    if ((watch('roles')?.sid != "2" && watch('roles')?.sid !== "")) {
      data.chainId.chainID = watch("chainId").chainID
    }
    delete payload.roles;
    callAPI(url, method, payload)
      .then(function (response) {
        setCreateUpdatePopUp(response.message);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const handleReset = () => {
    reset();
  };

  // const handleCancelButton = (e) => {
  //   e.preventDefault();
  //   navigate(-1);
  // };

  useEffect(() => {
    const apiPath = `/master?type=ROLES`;
    callAPI(apiPath, "GET")
      .then((res) => {
        const data = res.data;
        setRoles(data);
      })
      .catch((err) => {
        console.warn(err.message);
      });

    callAPI("/hotel/list", "GET")
      .then((res) => {
        const data = res.data;
        setHotelsList(data);
      })
      .catch((err) => {
        console.warn(err.message);
      });


  }, []);

  useEffect(() => {
    if (
      location?.state?.isEditUser ||
      location?.state?.isPendingApprovalStatus
    ) {
      const { sid } = location?.state;
      callAPI(`user?sid=${sid}`, "GET")
        .then(function (response) {
          const role = roles.find(
            (role) => role.sid === response?.roles[0]?.id
          );
          const hotelApiList = response?.chainIdHotelNameMapping?.map((hotel) => hotel?.chainId);
          const hotel = hotels?.filter((hotel) => hotelApiList.includes(hotel?.chainID));
          // const hotel = hotels?.find((hotel) => hotel?.chainID === response?.chainId);
          const accessTillDate = response.accessTillDate ? new Date(response.accessTillDate).toISOString().split("T")[0] : ""
          // const accessTillDate = new Date(response.accessTillDate);
          // const formattedDate = isNaN(accessTillDate.getTime())
          //   ? null
          //   : accessTillDate.toISOString().split("T")[0];
          const payload = {
            userName: response?.userName,
            accessTillDate: accessTillDate,
            enabled: response?.enabled,
            firstName: response?.firstName,
            lastName: response?.lastName,
            phoneNo: response?.phoneNo,
            chainId: hotel || {},
            roles: role || {},
          };
          reset(payload);
        })
        .catch(function (error) {
          console.warn(error.response?.data?.errorMessage);
        });
    }
  }, [location?.state, reset, roles, hotels]);

  const closePopupHandler = () => {
    setCreateUpdatePopUp("");
    navigate("/hms/userList");
  };

  const cancelPopupHandler = () => {
    setCancelPopup(false)
    navigate("/hms/userList");
  }

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>
          {location?.state?.isPendingApprovalStatus || location?.state?.isEditUser && <li>
            <Link to="/hms/userList">User Management List</Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>}
          <li>
            {location?.state?.isPendingApprovalStatus
              ? "Approve User"
              : location?.state?.isEditUser
                ? "Edit User"
                : "Create User"}
          </li>
        </ul>
      </div>
      <div className="sub-header">
        <h1>
          {location?.state?.isPendingApprovalStatus
            ? "Approve User"
            : location?.state?.isEditUser
              ? "Edit User"
              : "Create User"}
        </h1>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="create-edit-user">
        <div className="row">
          <div className="col-4">
            <label htmlFor="userName">Email <span className="required">*</span></label>
            <input
              id="userName"
              className="form-control"
              placeholder="Enter Email"
              disabled={location?.state?.isEditUser || location?.state?.isPendingApprovalStatus}
              maxLength={60}
              {...register("userName", {
                required: "Please Enter Your Email",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please Enter Email in correct format",
                },
              })}
            />
            {errors.userName && (
              <p className="required">{errors.userName.message}</p>
            )}
          </div>

          <div className="col-4">
            <label htmlFor="firstName">First Name<span className="required">*</span></label>
            <input
              id="firstName"
              className="form-control"
              placeholder="Enter First Name"
              type="text"
              maxLength={30}
              {...register("firstName", {
                required: "Enter First Name",
                pattern: {
                  value: /^[A-Za-z]+(?:[A-Za-z]+)*$/,
                  message: 'Enter Alphabets only',
                }
              })}
            />
            {errors.firstName && (
              <p className="required">{errors.firstName.message}</p>
            )}
          </div>

          <div className="col-4">
            <label htmlFor="lastName">Last Name</label>
            <input
              id="lastName"
              className="form-control"
              placeholder="Enter Last Name"
              type="text"
              maxLength={30}
              {...register("lastName", {
                pattern: {
                  value: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
                  message: 'Enter Alphabets only',
                }
              })}
            />
            {errors.lastName && (
              <p className="required">{errors.lastName.message}</p>
            )}
          </div>

          <div className="col-4">
            <label htmlFor="phoneNo">Phone<span className="required">*</span></label>
            <input
              id="phoneNo"
              className="form-control"
              placeholder="Enter Phone Number"
              type="tel"
              // maxLength={12}
              // minLength={10}
              {...register("phoneNo", {
                required: "Please Enter Phone Number",
                pattern: {
                  value: /^[0-9]{10,12}$/,
                  message: "Phone number must be between 10 and 12 digits",
                },
              })}
            />
            {errors.phoneNo && (
              <p className="required">{errors.phoneNo.message}</p>
            )}
          </div>

          <div className="col-4">
            <label htmlFor="roles">User Role<span className="required">*</span></label>
            <Controller
              name="roles"
              control={control}
              rules={{
                validate: (value) => (location?.state?.isPendingApprovalStatus?Object.entries(value===null?{}:value).length>0:value !== undefined && value !== null && value !== '') || 'Selecting a role is required',
              }}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  className="select-dropdown"
                  disablePortal
                  options={roles}
                  getOptionLabel={(option) => option.name || ""}
                  isOptionEqualToValue={(option, value) => option.sid === value?.sid}
                  onChange={(_, newValue) => {
                    field.onChange(newValue);
                  }}
                  value={field.value || null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Please Select User Role"

                    />
                  )}
                />
              )}
            />
            {errors.roles && (
              <p className="required">{errors.roles.message}</p>
            )}
          </div>

          {(watch('roles')?.sid != "2" && watch('roles')?.sid !== "") && <div className="col-4">
            <label htmlFor="chainId">Link Hotel<span className="required">*</span></label>
            {/* <select
              id="chainId"
              className="form-control"
              {...register("chainId", {
                required: "Linking a Hotel is required",
              })}
            >
              <option className="custom-placeholder" hidden value="">Please Link Hotel...</option>
              {hotels?.map((hotel) => (
                <option key={hotel?.id} value={hotel?.chainID}>
                  {hotel?.hotelName}
                </option>
              ))}
            </select> */}
            <Controller
              name="chainId"
              control={control}
              rules={{
                validate: (value) =>
                  (location?.state?.isPendingApprovalStatus
                    ? Object.entries(value === null ? {} : value).length > 0
                    : value !== undefined && value !== null && value.length > 0) || "Linking a Hotel is required",
              }}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  className="select-dropdown"
                  limitTags={1}
                  disablePortal
                  multiple
                  disableCloseOnSelect
                  options={hotels}
                  getOptionLabel={(option) => option.hotelName || ""}
                  isOptionEqualToValue={(option, value) => option.chainID === value?.chainID}
                  onChange={(_, newValue, reason) => {
                    if (reason === "clear") {
                      setPendingClear(() => () => field.onChange([])); // store callback
                      setCancelPopupClearHotel(true); // open modal
                    } else {
                      field.onChange(newValue);
                    }
                  }}
                  value={field.value || []}
                  renderInput={(params) => <TextField {...params} placeholder="Please Link Hotels" />}
                />
              )}
            />
            {errors.chainId && (
              <p className="required">{errors.chainId.message}</p>
            )}
          </div>}

          <div className="col-4">
            <label htmlFor="accessTillDate">Access Till Date</label>
            <input
              id="accessTillDate"
              type="date"
              className="form-control"
              min={today}
              {...register("accessTillDate")}
            />
            {errors.accessTillDate && (
              <p className="required">{errors.accessTillDate.message}</p>
            )}
          </div>

          <div className="col-12">
            <label htmlFor="enabled"> User  {!watch("enabled") ? "Disabled" : "Enabled"}</label>
            <Switch
              id="enabled"
              className={`form-control border-0 ${!watch("enabled")
                ? "switchuser-inactive"
                : "switchuser-active"
                }`}
              checked={watch("enabled")}
              onChange={handleSwitchChange}
              {...register("enabled")}
            />
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn_new"
              onClick={() => setCancelPopup(true)}
            >
              Cancel
            </button>
            {!location?.state?.isPendingApprovalStatus && (
              <button type="button" className="reset-btn" onClick={handleReset}>
                Reset
              </button>
            )}
            <button type="submit" className="create-btn">
              {location?.state?.isPendingApprovalStatus
                ? "Approve"
                : location?.state?.isEditUser
                  ? "Update"
                  : "Create"}
            </button>
          </div>
        </div>
      </form>
      <BasicModal
        popupOpen={createUpdatePopUp !== ""}
        bodyMessage={<>
          {createUpdatePopUp && (
            <span className="d-block">
              <img src="/Images/approve-qc.png" alt="approve" style={{ width: 60 }} />
              <p className="mt-2">{createUpdatePopUp}</p>
            </span>
          )}
        </>
        }
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: closePopupHandler
            }
          }
        }
      />
      <BasicModal
        popupOpen={cancelPopup}
        bodyMessage={"Do you really want to cancel it?"}
        logo={"/Images/Rejected.png"}
        footer={
          {
            primaryButton: {
              buttonName: "Cancel",
              action: () => setCancelPopup(false)
            },
            secondaryButton: {
              buttonName: "Yes",
              action: cancelPopupHandler
            }
          }
        }
      />
      <BasicModal
        popupOpen={cancelPopupClearHotel}
        bodyMessage={"Do you really want to unlink all Hotels?"}
        logo={"/Images/Rejected.png"}
        footer={{
          primaryButton: {
            buttonName: "Cancel",
            action: () => {
              setCancelPopupClearHotel(false);
              setPendingClear(null);
            },
          },
          secondaryButton: {
            buttonName: "Yes",
            action: cancelPopupHandlerClearHotel,
          },
        }}
      />
    </>
  );
};

export default CreateEditUser;
